import type { DriverEntity } from '@/features/driver/domain/entities/DriverEntity'
import type { FileUploadEntity } from '@/shared/entities/FileUploadEntity'

export class PostDriverBreakEntity {
  driver?: DriverEntity | null
  startAt?: Date | string | null
  endAt?: Date | string | null
  reason?: string | null
  attachmentImage?: FileUploadEntity | null
  reviewNotes?: string | null
}
